import { form } from '../formState'

import { useValidateEmail } from '@/hooks'
import { useTexts } from '../../hooks/useTexts'
import { createValidateCompanyEmail } from '../hooks/useFormValidation'
import { useUpdateEmailRelatedFields } from '../hooks/useUpdateEmailRelatedFields'

export function CompanyEmail() {
  const texts = useTexts()
  const validateEmail = useValidateEmail()
  useUpdateEmailRelatedFields()

  form.useAddFieldValidation<'companyEmail'>('companyEmail', async (field, _formApi) => {
    const companyEmailValidation = await createValidateCompanyEmail(
      texts,
      field.value,
      validateEmail,
    )
    return (
      companyEmailValidation.companyEmailRequired?.message ||
      companyEmailValidation.companyEmailInvalid?.message
    )
  })

  return (
    <>
      <form.TextField
        name="companyEmail"
        testId="companyEmail"
        label={texts.companyEmail}
        validateOn="focus blur"
      />

      <form.Checkbox
        name="showContactEmail"
        testId="showContactEmail"
        label={texts.showContactEmailonForm}
        validateOn="focus blur"
      />

      <form.Checkbox
        name="useCompanyEmailAsReplyTo"
        testId="useCompanyEmailAsReplyTo"
        label={texts.useCompanyEmailAsReplyTo}
        validateOn="focus blur"
      />
    </>
  )
}
